<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { AppDialog, AppToast } from 'duanaga-ui'
import AuthLayout from '@/layouts/AuthLayout.vue'
import GuestLayout from '@/layouts/GuestLayout.vue'

const route = useRoute()

const layoutComponent = computed(() => {
  return route.meta.layout === 'guest' ? GuestLayout : AuthLayout
})
</script>

<template>
  <component :is="layoutComponent">
    <RouterView />
    <AppDialog />
    <AppToast />
  </component>
</template>
